<template>
  <ComingSoon />
</template>

<script>
import ComingSoon from "./ComingSoon"

export default {
  name: 'RewardsEarnMoreTab',

  components: { ComingSoon },
}
</script>